<template>
  <div>
    <el-tabs>
      <el-tab-pane v-for="tab in data.tabs" :key="tab.tabName" :label="tab.tabName">
        Для юр. лиц:
        <price-table :data="tab.yl" />
        Для ИП:
        <price-table :data="tab.ip" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import PriceTable from './PriceTable.vue'

  export default {
    components: {
      PriceTable
    },

    props: {
      data: Object
    }
  }
</script>